import React, { Component } from 'react';
import { PlusCircle } from '@nackle/icons';
import { Button, Card, Form } from '@nackle/paper';
import sortBy from 'lodash/sortBy';
import { Cabinet, Rom } from 'shared/interfaces';

interface CabinetOption extends Cabinet {
    readonly disabled?: boolean;
}
interface RomOption extends Rom {
    readonly disabled?: boolean;
}

export interface SelectGameProps {
    readonly addButtonText: string;
    readonly getOptions: any;
    readonly selectGame: any;
    readonly gameOptions: Array<CabinetOption | RomOption>;
    readonly idKey: string;
    readonly labelText?: string;
}

export default class SelectGame extends Component<SelectGameProps>{
    static defaultProps = {
        gameOptions: [],
        labelText: 'Add Game'
    };
    state = {
        gameId: '',
        gameName: ''
    };
    constructor(props) {
        super(props);
        props.getOptions();
    }
    queueGame = (event) => {
        const { value } = event.target;
        this.setState({ gameId: value });
    };
    selectGame = async () => {
        const idKey = this.props.idKey;
        const game = this.props.gameOptions.find(option => option[ idKey ] === this.state.gameId);
        this.props.selectGame(game);
    };
    selectGameButtonDisabled = () => {
        const selectedGameId = this.state.gameId;
        const { gameOptions, idKey } = this.props;
        const selectGameButtonDisabled = (!selectedGameId || gameOptions.find(option => option[ idKey ] === selectedGameId && option.disabled));
        return !!selectGameButtonDisabled;
    };
    selectGameSelectDisabled = () => {
        const { gameOptions } = this.props;
        const disabledOptions = gameOptions.filter(option => option.disabled && option);
        const hasGameOptions = !!gameOptions.length;
        const allOptionsDisabled = gameOptions.length === disabledOptions.length;
        return (!hasGameOptions || allOptionsDisabled);
    };
    render() {
        const { addButtonText, gameOptions, idKey, labelText } = this.props;
        const hasGameOptions = !!gameOptions.length;
        const selectGameButtonDisabled = this.selectGameButtonDisabled();
        const selectGameSelectDisabled = this.selectGameSelectDisabled();
        return (
            <div className="arcade-games-select-games-wrapper">
                <Card>
                    <Form.Item label={labelText}>                        
                        {
                            !hasGameOptions &&
                            <span>: no options available</span>
                        }
                            <select
                                id="selectGameSelect"
                                // dropdownClassName="games"
                                value={this.state.gameId}
                                onChange={this.queueGame}
                                disabled={selectGameSelectDisabled}
                                style={{ width: 400, marginRight: 10 }}
                            >
                                <option hidden value="">Select</option>
                                {
                                    sortBy(gameOptions, 'name').map(option =>
                                        <option
                                            key={`game-option-${option[ idKey ]}`}
                                            disabled={option.disabled}
                                            value={option[ idKey ]}
                                            onChange={this.queueGame}
                                        >
                                            {option.name}
                                        </option>
                                    )
                                }
                            </select>

                            <Button
                                icon={<PlusCircle/>}
                                id="selectGameButton"
                                onClick={this.selectGame}
                                disabled={selectGameButtonDisabled}
                            >
                                {addButtonText}
                            </Button>
                    </Form.Item>
                </Card>
            </div>
        );
    }
}
